import { render } from "./detail-view.vue?vue&type=template&id=18f06dcc&scoped=true"
import script from "./detail-view.vue?vue&type=script&lang=js"
export * from "./detail-view.vue?vue&type=script&lang=js"

import "./detail-view.vue?vue&type=style&index=0&id=18f06dcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f06dcc"]])

export default __exports__